var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006161",
    fillRule: "evenodd",
    d: "M9.382 1.515 4.96 6.875a2 2 0 0 1-3.143-.073L.334 4.824l1.067-.8 1.483 1.978a.667.667 0 0 0 1.047.024L8.353.666z",
    clipRule: "evenodd"
  })));
};
export default SvgCheck;